import FeedbackPage from "@components/FeedbackPage"

export default function SustainableApproach() {
  return (
    <FeedbackPage
      emoji="🌱"
      titleKey="pages.onboarding.sustainableApproach.heading"
      textKey="pages.onboarding.sustainableApproach.info"
      points={[
        "pages.onboarding.sustainableApproach.point1",
        "pages.onboarding.sustainableApproach.point2",
        "pages.onboarding.sustainableApproach.point3",
      ]}
    />
  )
}
